@if (busy) {
  <article>
    <div>
      @if (message) {
        <h5>{{ message }}</h5>
      }
      <img src="assets\images\cmi-icons\loading.gif" alt="Loading" height="48" />
    </div>
  </article>
}
